import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import { AppContext } from '../../AppProvider';
import ErrorNotification from '../../components/common/ErrorNotification';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';

import { sanitize } from '../../Models/RegularUser';

import * as Queries from '../../graphQL/queries/userQueries';
import * as Mutations from '../../graphQL/mutations/userMutations';
import * as LocationQueries from '../../graphQL/queries/locationQueries';
import * as OrgUserMutations from '../../graphQL/mutations/orgUserMutations';
import Grid from '@material-ui/core/Grid';

import _get from 'lodash/get';
import _find from 'lodash/find';
import _isNumber from 'lodash/isNumber'

import EditProfileModal from '../../components/myaccount/modals/EditProfileModal';
import EditDefaultLocationModal from '../../components/myaccount/modals/EditDefaultLocationModal';
import ChangeLoginEmailModal from '../../components/myaccount/modals/ChangeLoginEmailModal';
import MyAccountProfile from '../../components/myaccount/Profile';
import MyAccountDefaultLocation from '../../components/myaccount/DefaultLocation';
import MyAccountEmailNotification from '../../components/myaccount/EmailNotification';

const styles = theme => ({
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5
  },
  title: {
    flex: 1
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(12,31,44, 0.04)'
    }
  }
});

export class MyAccount extends Component {
  state = {
    myUser: {},
    orgId: this.context.globalProps.currentOrgId,
    defaultLocation: {},
    allOrgLocations: [],
    referenceFields: {},
    loadingUserDetails: true,
    loadingDefaultLocation: true,
    loadingAllLocations: true,
    error: null,
    errorsOnSave: null,
    isEmailEnabled: true,
    isOpenedEditProfileModal: false,
    isOpenedChangeLoginEmailModal: false,
    isOpenedEditDefaultLocation: false,
    isSubmitting: false,
    isResettingPassword: false
  };

  async componentDidMount() {
    this._getRefData();
    this._loadAllLocations();

    const { client: ApolloClient } = this.props;

    try {
      this.setState({ loadingUserDetails: true });

      const {
        data: {
          userAccess: {
            me: { user: myUser }
          }
        }
      } = await ApolloClient.query({
        query: Queries.userInfoOrgAccess
      });

      
      const isEmailEnabled = this._checkEmailEnabled(myUser);

      this.setState({
        myUser,
        isEmailEnabled
      });
    } catch (error) {
      
      this.setState({
        error
      });
    } finally {
      this.setState({
        loadingUserDetails: false
      });
    }

    await this._loadDefaultLocation();
  }

  _checkEmailEnabled = myUser => {
    const { referenceFields } = this.state;

    if (myUser.preferences.receiveEmailDigest) {
      return true;
    }

    let isEmailEnabled = false;
    referenceFields.notificationReasons.forEach(notificationReason => {
      let notificationPreference = _find(
        myUser.preferences.notificationPreferences,
        function(np) {
          return np.notificationReasonId === notificationReason.value;
        }
      );

      if (
        notificationPreference &&
        notificationPreference.receiveEmailNotifications
      ) {
        isEmailEnabled = true;
      }
    });

    return isEmailEnabled;
  };

  _getRefData = () => {
    const {
      timeZones,
      cultures,
      country,
      notificationReasons
    } = this.context.globalProps.referenceData;

    this.setState({
      referenceFields: {
        timeZones,
        cultures,
        country,
        notificationReasons
      }
    });
  };

  _loadDefaultLocation = async () => {
    const { client: ApolloClient } = this.props;
    const { myUser, orgId } = this.state;

    const currentOrgUser = _find(myUser.orgUsers, function(ou) {
      return ou.orgId.toString() === orgId.toString();
    });

    const defaultLocationId = _get(
      currentOrgUser,
      'preferences.defaultLocationId',
      null
    );

    if (defaultLocationId === null) {
      this.setState({ loadingDefaultLocation: false });
      return;
    }

    try {
      this.setState({ loadingDefaultLocation: true });

      const {
        data: {
          location: { byId: defaultLocation }
        }
      } = await ApolloClient.query({
        query: LocationQueries.byId,
        variables: { id: defaultLocationId }
      });

      this.setState({
        defaultLocation: defaultLocation
      });
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        loadingDefaultLocation: false
      });
    }
  };

  _loadAllLocations = async () => {
    const { client: ApolloClient } = this.props;
    const orgId = this.context.globalProps.currentOrgId;

    try {
      if (orgId) {
        this.setState({ loadingAllLocations: true });
        const {
          data: {
            location: { all: allOrgLocations }
          }
        } = await ApolloClient.query({
          query: LocationQueries.locationsByOrgIdQuery,
          variables: { orgId },
          fetchPolicy: 'network-only'
        });

        this.setState({
          allOrgLocations
        });
      }
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        loadingAllLocations: false
      });
    }
  };

  _handleEditProfile = () => {
    this.setState({ isOpenedEditProfileModal: true });
  };

  _handleCloseEditProfileModal = () =>
    this.setState({ isOpenedEditProfileModal: false });

  _handleSaveProfile = async userValues => {
    this.setState({ isSubmitting: true });
    const mutation = Mutations.updateUserMutation;

    try {
      // const { client: ApolloClient } = this.props;

      // const {
      //   data: {
      //     user: { update: myUser }
      //   }
      // } = await ApolloClient.mutate({
      //   mutation,
      //   variables: { user: sanitize(userValues) }
      // });

      // const isEmailEnabled = this._checkEmailEnabled(myUser);

      // this.setState({
      //   isOpenedEditProfileModal: false,
      //   errorsOnSave: null,
      //   myUser,
      //   isEmailEnabled
      // });
    } catch (errorsOnSave) {
      this.setState({ errorsOnSave });
      throw errorsOnSave;
    } finally {
      this.setState({
        isSubmitting: false
      });
    }
  };

  _handleChangeLoginEmail = () => {
    this.setState({ isOpenedChangeLoginEmailModal: true });
  };

  _handleCloseChangeLoginEmail = () =>
    this.setState({ isOpenedChangeLoginEmailModal: false });

  _handleSaveChangeLoginEmail = async userValues => {
    const { client: ApolloClient } = this.props;

    try {
      this.setState({ isSubmitting: true });
      const mutation = Mutations.changeUserEmailMutation;

      const {
        data: {
          user: { changeLoginEmail: myUser }
        }
      } = await ApolloClient.mutate({
        mutation,
        variables: {
          loginEmailChange: {
            userId: userValues.id,
            loginEmail: userValues.loginEmail,
            rowVersion: userValues.rowVersion
          }
        }
      });

      this.setState({
        isOpenedChangeLoginEmailModal: false,
        errorsOnSave: null,
        myUser
      });
    } catch (errorsOnSave) {
      this.setState({ errorsOnSave });
      throw errorsOnSave;
    } finally {
      this.setState({
        isSubmitting: false
      });
    }
  };

  _handleEditDefaultLocation = () =>
    this.setState({ isOpenedEditDefaultLocation: true });

  _handleCloseEditDefaultLocation = () =>
    this.setState({ isOpenedEditDefaultLocation: false });

  _handleSaveDefaultLocation = async defaultLocation => {
    const { client: ApolloClient } = this.props;
    const { myUser, orgId, allOrgLocations } = this.state;
    const currentOrgUser = _find(myUser.orgUsers, function(ou) {
      return ou.orgId.toString() === orgId.toString();
    }) || myUser.orgUsers[0];
    // TODO: do somtheing when is not a number
    if(!parseInt(defaultLocation.location)) return;
    
    const defaultLocationId = parseInt(defaultLocation.location);
    

    try {
      this.setState({ isSubmitting: true });
      const mutation = OrgUserMutations.updateOrgUserMutation;

      await ApolloClient.mutate({
        mutation,
        variables: {
          orgUser: { id: currentOrgUser.id, preferences: { defaultLocationId } }
        }
      });

      this.setState({
        isOpenedEditDefaultLocation: false,
        errorsOnSave: null,
        defaultLocation: _find(allOrgLocations, function(l) {
          return l.id.toString() === defaultLocationId.toString();
        })
      });
    } catch (errorsOnSave) {
      this.setState({ errorsOnSave });
      throw errorsOnSave;
    } finally {
      this.setState({
        isSubmitting: false
      });
    }
  };

  _handleResetPassword = async () => {
    const { client: ApolloClient } = this.props;
    const { orgId, myUser } = this.state;
    try {
      this.setState({ isResettingPassword: true });
      const mutation = Mutations.resetUserPassword;

      await ApolloClient.mutate({
        mutation,
        variables: { userInfo: { orgId, userId: myUser.id } }
      });

      this.setState({
        errorsOnSave: null
      });
    } catch (errorsOnSave) {
      this.setState({ errorsOnSave });
      throw errorsOnSave;
    } finally {
      this.setState({
        isResettingPassword: false
      });
    }
  };

  _handleEmailToggle = toggleValue => {
    const { myUser, referenceFields } = this.state;
    myUser.preferences.receiveEmailDigest = toggleValue;

    referenceFields.notificationReasons.forEach(notificationReason => {
      const notificationPreference = _find(
        myUser.preferences.notificationPreferences,
        function(np) {
          return np.notificationReasonId === notificationReason.value;
        }
      );
      if(notificationPreference){
        notificationPreference.receiveEmailNotifications = toggleValue;
        notificationPreference.includeInEmailDigest = toggleValue;
      }
    });

    this._handleSaveProfile(myUser);
  };

  _handleEmailDigestToggle = toggleValue => {
    const { myUser } = this.state;
    myUser.preferences.receiveEmailDigest = toggleValue;

    this._handleSaveProfile(myUser);
  };

  _handleEmailDigestAllToggle = toggleValue => {
    const { myUser } = this.state;
    myUser.preferences.emailDigestReceiveAll = toggleValue;

    this._handleSaveProfile(myUser);
  };

  _handleNotificationPreferenceEmail = notificationReason => {
    const { myUser } = this.state;

   const mappedNotReason = {
    notificationReasonId: notificationReason.value,
    receiveEmailNotifications: true,
    includeInEmailDigest: false,          
    receiveInAppNotifications: false
   };


    if (!myUser.preferences.notificationPreferences) {
      myUser.preferences.notificationPreferences = [mappedNotReason];
      this._handleSaveProfile(myUser);
      return;
    }

    const userNotificationIdx = myUser.preferences.notificationPreferences.findIndex(
      x => x.notificationReasonId === notificationReason.value
    );

    if (userNotificationIdx === -1) {
      myUser.preferences.notificationPreferences.push(mappedNotReason);
    } else {
      myUser.preferences.notificationPreferences[userNotificationIdx].receiveEmailNotifications = !myUser.preferences.notificationPreferences[userNotificationIdx].receiveEmailNotifications;
    }

    this._handleSaveProfile(myUser);
  };

  _handleNotificationPreferenceDigest = notificationReason => {
    const { myUser } = this.state;
    const originalValue = _find(
      myUser.preferences.notificationPreferences,
      function(np) {
        return np.notificationReasonId === notificationReason.value;
      }
    ).includeInEmailDigest;

    _find(myUser.preferences.notificationPreferences, function(np) {
      return np.notificationReasonId === notificationReason.value;
    }).includeInEmailDigest = !originalValue;

    this._handleSaveProfile(myUser);
  };

  render() {
    const { t, classes } = this.props;
    const { myUser, defaultLocation, referenceFields } = this.state;

    if (this.state.error) {
      return <ErrorNotification message="Error loading page" />;
    }

    return (
      <div>
        <div className={classes.titleWrapper}>
          <h1
            className={classnames(
              classes.headline4,
              classes.noMarginBottom,
              classes.title
            )}
          >
            {t('My Account')}
          </h1>
        </div>
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <MyAccountProfile
              myUser={myUser}
              isLoading={this.state.loadingUserDetails}
              referenceFields={referenceFields}
              onResetPassword={this._handleResetPassword}
              onChangeLoginEmail={this._handleChangeLoginEmail}
              onEditProfile={this._handleEditProfile}
              isResettingPassword={this.state.isResettingPassword}
            />

            <MyAccountDefaultLocation
              isLoading={this.state.loadingUserDetails}
              defaultLocation={defaultLocation}
              onEditLocation={this._handleEditDefaultLocation}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MyAccountEmailNotification
              isLoading={this.state.loadingUserDetails}
              isSubmitting={this.state.isSubmitting}
              notificationReasons={referenceFields.notificationReasons}
              myUser={myUser}
              isEmailEnabled={this.state.isEmailEnabled}
              handleEmailToggle={this._handleEmailToggle}
              handleEmailDigestToggle={this._handleEmailDigestToggle}
              handleEmailDigestAllToggle={this._handleEmailDigestAllToggle}
              handleNotificationPreferenceDigest={
                this._handleNotificationPreferenceDigest
              }
              handleNotificationPreferenceEmail={
                this._handleNotificationPreferenceEmail
              }
            />
          </Grid>
        </Grid>
        <EditProfileModal
          open={this.state.isOpenedEditProfileModal}
          user={this.state.myUser}
          referenceFields={this.state.referenceFields}
          onClose={this._handleCloseEditProfileModal}
          onSave={this._handleSaveProfile}
          isSubmitting={this.state.isSubmitting}
        />
        <ChangeLoginEmailModal
          open={this.state.isOpenedChangeLoginEmailModal}
          user={this.state.myUser}
          onClose={this._handleCloseChangeLoginEmail}
          onSave={this._handleSaveChangeLoginEmail}
          isSubmitting={this.state.isSubmitting}
        />
        <EditDefaultLocationModal
          open={this.state.isOpenedEditDefaultLocation}
          defaultLocationId={this.state.defaultLocation.id}
          allOrgLocations={this.state.allOrgLocations}
          onClose={this._handleCloseEditDefaultLocation}
          onSave={this._handleSaveDefaultLocation}
          isSubmitting={this.state.isSubmitting}
        />
        {this.state.errorsOnSave && (
          <ErrorNotification message={this.state.errorsOnSave.message} />
        )}
      </div>
    );
  }
}

MyAccount.contextType = AppContext;
const MyAccountWithTranslation = withNamespaces()(MyAccount);
export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    styles
  )
)(withApollo(MyAccountWithTranslation));
